import HomeScreen from "./HomeScreen";
import FileUploadScreen from "./FileUploadScreen";
import FourthScreen from "./FourthScreen";
import FifthScreen from "./FifthScreen";
import FullScreenFirst from "./FullScreenFirst";
import MyAccountScreen from "./MyAccountScreen";
import ImprintScreen from "./ImprintScreen";
import TermsOfUseScreen from "./TermsOfUseScreen";
import PrivacyPolicyScreen from "./PrivacyPolicyScreen";
import UploadsScreen from "./UploadsScreen";
import OrderHistoryScreen from "./OrderHistoryScreen";
import ModalScreen from "./ModalScreen";
import TicketsTrackingScreen from "./TicketsTrackingScreen";

/**
 * navSlug: screenIdentifier (must be unique)
 * noTabs: boolean, if set to true, screen will be rendered without tabs navigation (fullScreen view)
 * hasSubscreens: boolean, whether or not screen has subscreens
 * component: specific screen rendering component
 * headerOptions:
 *  menuArea: string icon/functionality to display on left hand side of header
 *    (options: null (nothing), 'menu' (displays menu icon), 'back' (displays back icon, mandatory on subpages and noTabs screens)
 *  headerTitle: string,  title to be displayed in header
 *  headerIcons: array of icon/functionality to be displayed on right hand side of header
 *  showLogo: boolean, whether to display or not top row of header containing logo and site title
 * showCopyright: boolean, display copyright notice at bottom edge of screen (default: false)
 * screenTitle: string, title/description to be displayed on top of screen content area, (string or null if no title is to be displayed)
 * icon: string, icon associtated with page/screen to be displayed in tabs navigation
 * navTitle: string,  title associated with page/screen to be displayed below icon in tabs navigation
 * subScreens: array of screen objects representing sub screens of current screen
 */

export const screensConfig = [
  {
    navSlug: 'Home',
    noTabs: false,
    hasSubscreens: false,
    component: HomeScreen,
    headerOptions: {
      menuArea: null,
      headerTitle: 'application.main.title',
      headerIcons: [],
      showLogo: false,
    },
    screenTitle: '',
    icon: 'home',
    navTitle: 'header.title.home',
    countries: {
      "ar": true,
      "la": true,
      "br": true,
      "cl": true,
      "co": true,
      "ec": true,
      "pe": true,
      "uy": true
    }
  },
  {
    navSlug: 'orderHistoryScreen',
    noTabs: false,
    hasSubscreens: false,
    component: OrderHistoryScreen,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.order.history.screen',
      headerIcons: [],
      showLogo: false
    },
    screenTitle: '',
    icon: 'delivery',
    navTitle: 'nav.tab.order.history.screen.icon.title',
    countries: {
      "ar": true,
      "la": true,
      "br": true,
      "cl": true,
      "co": true,
      "ec": true,
      "pe": true,
      "uy": true
    }
  },
  {
    navSlug: 'uploadsScreen',
    noTabs: false,
    hasSubscreens: false,
    component: UploadsScreen,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.uploads.screen',
      headerIcons: [],
      showLogo: false
    },
    screenTitle: '',
    icon: 'document-arrow-up',
    navTitle: 'nav.tab.uploads.screen.icon.title',
    countries: {
      "ar": true,
      "la": true,
      "br": true,
      "cl": true,
      "co": true,
      "ec": true,
      "pe": true,
      "uy": true
    }
  },
    {
      navSlug: 'tickets',
      noTabs: false,
      hasSubscreens: false,
      component: TicketsTrackingScreen,
      headerOptions: {
        menuArea: null,
        headerTitle: 'header.title.tickets.screen',
        headerIcons: [],
        showLogo: false,
      },
      screenTitle: '',
      icon: 'ticket',
      navTitle: 'nav.tab.tickets.screen.icon.title',
      showCopyright: true,
      countries: {
        "ar": true,
        "la": false,
        "br": true,
        "cl": true,
        "co": true,
        "ec": true,
        "pe": true,
        "uy": true
      }
    },
  /* These are left here as examples of different configurations for screens
    {
      navSlug: 'FourthScreen',
      noTabs: false,
      hasSubscreens: true,
      component: FourthScreen,
      headerOptions: {
        menuArea: 'null',
        headerTitle: 'header.title.fourth.screen',
        headerIcons: ['settings'],
        showLogo: true,
      },
      screenTitle: '',
      icon: 'helmet',
      navTitle: 'header.title.home',
      subScreens: [
        {
          navSlug: 'FifthScreen',
          component: FifthScreen,
          noTabs:false,
          hasSubscreens:false,
          headerOptions: {
            menuArea: null,
            headerTitle: 'header.title.fifth.screen',
            headerIcons: [],
            showLogo: false,
          },
          screenTitle: 'This is the fifth page, unused at the moment, inserted in order to test sub navigation',
          icon: null,
          navTitle: 'header.title.home',
        }
      ]
    },
    {
      navSlug: 'fullScreen1',
      noTabs: true,
      hasSubscreens: false,
      component: FullScreenFirst,
      headerOptions: {
        menuArea: 'back',
        headerTitle: 'header.title.full.screen.first.screen',
        headerIcons: [],
        showLogo: true,
      },
      footerOptions: {
        showFooter: true,
        hideTermsOfUse: false,
        hidePrivacyPolicy: false,
        hideImprint: false,
        hideCopyright: false
      },
      screenTitle: '',
      icon: null,
      navTitle: '',
    },
  */
  {
    navSlug: 'MyAccount',
    noTabs: false,
    hasSubscreens: false,
    component: MyAccountScreen,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.my.account.screen',
      headerIcons: [],
      showLogo: false,
    },
    screenTitle: '',
    icon: 'list-view-mobile',
    navTitle: 'header.title.my.account.screen',
    showCopyright: true,
    countries: {
      "ar": true,
      "la": true,
      "br": true,
      "cl": true,
      "co": true,
      "ec": true,
      "pe": true,
      "uy": true
    }
  },
  {
    navSlug: 'Imprint',
    component: ImprintScreen,
    noTabs:true,
    hasSubscreens:false,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.legal.imprint.screen',
      headerIcons: [],
      showLogo: false,
    },
    footerOptions: {
      showFooter: true,
      hideTermsOfUse: true,
      hidePrivacyPolicy: true,
      hideImprint: true,
      hideCopyright: false
    },
    screenTitle: '',
    icon: null,
    navTitle: 'header.title.legal.imprint.screen',
    showCopyright: true,
    countries: {
      "ar": false,
      "la": false,
      "br": true,
      "cl": false,
      "co": false,
      "ec": false,
      "pe": false,
      "uy": false
    }
  },
  {
    navSlug: 'TermsOfUse',
    component: TermsOfUseScreen,
    noTabs:true,
    hasSubscreens:false,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.legal.terms.of.use.screen',
      headerIcons: [],
      showLogo: false,
    },
    screenTitle: null,
    icon: null,
    navTitle: 'header.title.legal.terms.of.use.screen',
    showCopyright: true,
    countries: {
      "ar": false,
      "la": false,
      "br": true,
      "cl": false,
      "co": false,
      "ec": false,
      "pe": false,
      "uy": false
    }
  },
  {
    navSlug: 'PrivacyPolicy',
    component: PrivacyPolicyScreen,
    noTabs:true,
    hasSubscreens:false,
    headerOptions: {
      menuArea: null,
      headerTitle: 'header.title.privacy.policy.screen',
      headerIcons: [],
      showLogo: false,
    },
    screenTitle: '',
    icon: null,
    navTitle: 'header.title.privacy.policy.screen',
    showCopyright: true,
    countries: {
      "ar": false,
      "la": false,
      "br": true,
      "cl": false,
      "co": false,
      "ec": false,
      "pe": false,
      "uy": false
    }
  },
  {
    navSlug: 'Modal',
    component: ModalScreen,
    noTabs:true,
    hasSubscreens:false,
    headerOptions: {
      menuArea: 'back',
      headerTitle: 'header.title.modal',
      headerIcons: [],
      showLogo: false,
    },
    footerOptions: {
      showFooter: true,
      hideTermsOfUse: true,
      hidePrivacyPolicy: true,
      hideImprint: true,
      hideCopyright: true
    },
    screenTitle: '',
    icon: null,
    navTitle: 'header.title.modal',
    showCopyright: false,
    countries: {
      "ar": true,
      "la": true,
      "br": true,
      "cl": true,
      "co": true,
      "ec": true,
      "pe": true,
      "uy": true
    }
  },

];
